/**
 * entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';

export class ContentBlock extends BaseModel {
    defaults() {
        return {
            id: null,
            type: null,
            content: null,
            order_nr: null,
            magazin_id: null,
            service_page_id: null,
            created: null,
            modified: null,
            creator_id: null,
            modifier_id: null,

            // view props:
            content_html: null,
        };
    }

    mutations() {
        return {
            id: Number,
            created: dayjs,
            modified: dayjs,
            order_nr: Number,
        };
    }

    entityName() {
        return 'contentBlock';
    }
}

export class ContentBlockCollection extends BaseCollection {
    options() {
        return {
            model: ContentBlock,
        };
    }

    entityName() {
        return 'contentBlock';
    }
}
